import Swiper from "swiper";
import { Scrollbar, A11y, Keyboard } from "swiper/modules";
import "swiper/css";

const token = (name, fallback) => parseFloat(getComputedStyle(document.documentElement).getPropertyValue(`--pk-${name}`)) || fallback;

function createSwiper(panel) {
	const el = panel.querySelector(".team-swiper");
	if (!el || el.swiper) return el?.swiper;

	return new Swiper(el, {
		modules: [Scrollbar, A11y, Keyboard],
		wrapperClass: "swiper-wrapper",
		slidesPerView: token("kennis-slider-per-view-mobile", 1.15),
		spaceBetween: token("slider-gap", 24),
		breakpoints: {
			[token("breakpoint-sm", 767) + 1]: { slidesPerView: token("kennis-slider-per-view-tablet", 2) },
			[token("breakpoint-md", 992) + 1]: { slidesPerView: token("kennis-slider-per-view", 3) },
		},
		grabCursor: true,
		watchOverflow: true,
		scrollbar: { el: panel.querySelector(".pk-slider-progress"), draggable: true },
		keyboard: { enabled: true, onlyInViewport: true },
		a11y: { enabled: true },
	});
}

function initTeamSlider() {
	document.querySelectorAll(".team_slider-layout").forEach((layout) => {
		const tabs = [...layout.querySelectorAll(".team-tab")];
		const panels = [...layout.querySelectorAll(".team-panel")];

		panels.filter((panel) => !panel.hidden).forEach(createSwiper);

		const select = (tab, focus = false) => {
			tabs.forEach((other) => {
				const active = other === tab;
				other.setAttribute("aria-selected", String(active));
				other.tabIndex = active ? 0 : -1;
				const panel = layout.querySelector(`#${other.getAttribute("aria-controls")}`);
				if (!panel) return;
				panel.hidden = !active;
				if (active) {
					panel.classList.remove("is-entering");
					void panel.offsetWidth;
					panel.classList.add("is-entering");
					const swiper = createSwiper(panel);
					swiper?.update();
					swiper?.slideTo(0, 0);
				}
			});
			if (focus) tab.focus();
		};

		tabs.forEach((tab, index) => {
			tab.addEventListener("click", () => select(tab));
			tab.addEventListener("keydown", (event) => {
				const keys = { ArrowRight: 1, ArrowLeft: -1, Home: -index, End: tabs.length - 1 - index };
				if (!(event.key in keys)) return;
				event.preventDefault();
				select(tabs[(index + keys[event.key] + tabs.length) % tabs.length], true);
			});
		});
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initTeamSlider);
} else {
	initTeamSlider();
}
